<template lang="">
    <section class="find-job section login_wrapper">
        <div class="container">
            <div class="col-md-12 row"><label class="titulo4">Resumen</label></div>  
        </div>        
    </section>
</template>
<script>
export default {
    
}
</script>
<style lang="">
    
</style>


// WEBPACK FOOTER //
// panelView.vue?73d66cd5